import {Component, OnInit} from '@angular/core';
import {PlaceService} from "../../services/domain/place.service";
import {ConfirmationService} from "primeng/api";
import {DocumentService} from "../../services/domain/document.service";
import {BasePageComponent} from "../../base-page.component";
import {
  DocumentiArchivio,
  DocumentiArchivioGetListDocumentiTipoSezioneViewModel,
  DocumentiTipoSezione,
  FilePreviewViewModel,
  GetFilesViewModelPortas, UpdateExtraInfoViewModel
} from "../../models/documenti.models";
import {AuthService} from "../../services/auth.service";
import {saveAs} from "file-saver";

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css'],
  providers : [DocumentService,PlaceService,ConfirmationService]
})
export class DocumentComponent extends BasePageComponent implements OnInit{
  constructor(private documentService : DocumentService,
              private placeService : PlaceService,
              private confirmationService : ConfirmationService) {
    super();
  }
  public lstDocument : DocumentiArchivio[] = [];
  public lstSezioni : DocumentiTipoSezione[] = [];
  public documentListFilter : GetFilesViewModelPortas = new GetFilesViewModelPortas();
  public showModalShowDocument : boolean = false;
  public showModalInsertDocument : boolean = false;
  public filePreviewRequest : FilePreviewViewModel = new FilePreviewViewModel();
  public src: string = "";
  public blob : Blob = new Blob();
  public fileName : string = "";
  public fileIdEnc : string = "";
  public canUploadDocument :boolean = false;
  public documentmodel : DocumentiArchivioGetListDocumentiTipoSezioneViewModel = new DocumentiArchivioGetListDocumentiTipoSezioneViewModel();
  public totalDocument : number = 0;
  public idSezioneSelected : number = 0;
  ngOnInit(): void {
    this.getSezioniList();
  }

  public getDocumentListPaged(event:any, idSezione : number){
    if(event != null){
      this.documentListFilter.Offset = event.first;
      this.documentListFilter.Count = event.rows;
    }
    else {
      this.documentListFilter.Count = 10;
      this.documentListFilter.Offset = 0;
    }
    this.documentListFilter.IdSezione = idSezione;
    this.documentListFilter.IdAnagraficaUtente = AuthService.LoggedUser?.profileId ?? 0;
    this.asyncCall(() =>this.documentService.getListPaged(this.documentListFilter), response => {
      this.lstDocument = response.Item?.DocumentiArchivio || [];
      this.totalDocument = response.Item?.TotalDocument ?? 0;
      this.canUploadDocument = response.Item?.UserCanUploadDocument ?? false;
    })
  }


  public getSezioniList(){
    this.asyncCall(() => this.documentService.getSezioniList(AuthService.LoggedUser?.profileId ?? 0,this.documentmodel), response => {
      this.lstSezioni = response.Items || [];
    });
  }

  public showDocument(selectedDocument : DocumentiArchivio){
    this.showModalShowDocument = true;
    this.fileIdEnc = selectedDocument.IdDocumentiArchivioEnc;
    this.getFilePreview(selectedDocument);
  }

  public downloadDocument(selectedDocument : DocumentiArchivio){
    this.filePreviewRequest.Id = selectedDocument.IdDocumentiArchivioEnc;
    this.showSpinner();
    this.documentService.getFilePreview(this.filePreviewRequest).subscribe(response => {
      const blob = new Blob([response], {type: response.type});
      saveAs(blob,selectedDocument.BlobName );
      this.hideSpinner();
    });
  }

  public deleteDocument(selectedDocument : DocumentiArchivio){
    this.filePreviewRequest.Id = selectedDocument.IdDocumentiArchivioEnc;
    this.confirmationService.confirm({
      message: 'Sicuro di voler eliminare questo documento?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.asyncCall(() => this.documentService.deleteDocument(this.filePreviewRequest), response =>{
          this.showSuccess("Dati eliminati correttamente");
          this.getDocumentListPaged(null,selectedDocument.IdSezione);
        })
      }
    });
  }

  public getFilePreview(selectedDocument : DocumentiArchivio){
    this.filePreviewRequest.Id = selectedDocument.IdDocumentiArchivioEnc;
    this.showSpinner();
    this.documentService.getFilePreview(this.filePreviewRequest).subscribe(response => {
      this.blob = new Blob([response], {type: response.type});
      this.fileName = selectedDocument.FileName;
      this.authService.getSrcFromBlob(this.blob).then((value) => {
        this.src = value;
      });
      this.hideSpinner();
    });
  }

  public addNewDocument(){
    this.showModalInsertDocument = true;
  }

  public updateExtraInfo(document : DocumentiArchivio){
    let model = new UpdateExtraInfoViewModel();
    model.ExtraInfoValue = document.InRinnovo ? "1" : "0";
    model.IdDocumentiArchivioEnc = document.IdDocumentiArchivioEnc;
    model.IdDocumentiTipoExtraInfo = 57; //TODO anche nel vecchio veniva messo fisso così riga 3448 pagina DettaglioCandidato.js
    this.asyncCall(() => this.documentService.updateExtraInfo(model), response => {
      this.showMessageSaveCompleted();
      this.getDocumentListPaged(null, document.IdSezione);
    });
  }

  public onSaveDocument(){
    this.showModalInsertDocument = false;
    this.getSezioniList();
  }

  public selectTabSezione(idSezione : number){
    if(this.idSezioneSelected != idSezione){
      this.idSezioneSelected = idSezione;
      this.getDocumentListPaged(null,idSezione)
    }
  }

  protected readonly event = event;
}
